import { FC } from 'react';
import { NyhetResponse } from '../../types/pages';
import styles from './Nyhetstag.module.css';

import { Tag } from '@kpa/kul';

type NyhetstagProps = {
  nyhet: NyhetResponse;
};

const Nyhetstag: FC<NyhetstagProps> = ({ nyhet }) => {
  return (
    nyhet.category && nyhet.category.length > 0 && (
      <div className={styles.container}>
        {nyhet.category.map((kategori, index) => (
          <Tag className={styles.kategori} key={index} text={kategori} variant="neutral" />
        ))}
      </div>
    )
  );
};

export default Nyhetstag;
